module.exports = __webpack_public_path__ + "fonts/FilsonPro-Regular.5782353.ttf";